import { Box, useTheme } from "@mui/material";
import { useAiChatState } from "../../aiChat/AiChatContext";
import { usePaneSlots } from "../panes/usePanes";
import { useIsRailOnSmallScreen } from "./PaneFrame";
import { formatSpacerWidth, frameSlotAttribute, railTransition } from "./Rail.styles";

/**
 * The room the rail takes from the page. The panes themselves are fixed and out of flow, so this flex
 * item is what the content wrapper beside it yields to, through layout alone: it follows the spacer's
 * animated or dragged width in the same frame without reading any rail state of its own. Kept while the
 * chat is expanded so the page behind the overlay does not reflow twice.
 */
function RailSpacer() {
    const theme = useTheme();
    const { isOpen: isChatOpen, widthState } = useAiChatState();
    const { hasPaneOnRight } = usePaneSlots();
    const isSmallScreen = useIsRailOnSmallScreen();

    if (isSmallScreen) {
        return null;
    }

    return (
        <Box
            {...{ [frameSlotAttribute]: "spacer" }}
            sx={{ flexShrink: 0, transition: railTransition(theme, ["width"]) }}
            style={{ width: formatSpacerWidth(widthState.width, isChatOpen || hasPaneOnRight) }}
        />
    );
}

export default RailSpacer;
